// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demo-warp{width:100%;height:100%;position:fixed}.container{position:absolute;z-index:9999;background:rgba(0,0,0,.5);color:#fff}#cesiumContainer{width:100%;height:100%;position:absolute}", ""]);
// Exports
module.exports = exports;
